import Ezloadz from 'assets/images/logos/Ezloadz-logo.svg'; // UPDATE WHEN AVAILABLE
import production from './production';
import staging from './staging';
import development from './development';
import test from './test';

const configVariants = {
  production,
  staging,
  development,
  test,
};
const config = {
  freshworksId: 43000002433,
  authorityExpressFormName: 'Authority Express DART Signup - EZLoadz',
  partner: {
    url: 'https://app.ezloadz.com', // UPDATE WHEN AVAILABLE
    name: 'Ezloadz',
    partnerName: 'Ezlogz',
    logo: Ezloadz,
  },
  ...configVariants[process.env.NODE_ENV || 'development'],
};

export default config;
